import { Component, Input, OnInit } from '@angular/core';
import { BankHolidaysService } from '../../../services';
import { addYears } from 'date-fns';

@Component({
  selector: 'app-bank-holiday-warning',
  templateUrl: 'bank-holiday-warning.component.html',
  styleUrls: ['bank-holiday-warning.component.scss'],
})
export class BankHolidayWarningComponent implements OnInit {
  @Input() set earliest(value: string | Date) {
    this._earliest = this.ensureDate(value);
    this.checkWarning();
  }

  @Input() set latest(value: string | Date) {
    this._latest = this.ensureDate(value);
    this.checkWarning();
  }

  private _earliest: Date | null = null;
  private _latest: Date | null = null;
  private bhDates: Set<string> = new Set();

  warning = false;

  constructor(private holidayService: BankHolidaysService) {}

  ngOnInit() {
    void this.loadHolidayDates();
  }

  private async loadHolidayDates() {
    try {
      const now = new Date();
      const dates = await this.holidayService.getBankHolidays(addYears(now, -1), addYears(now, 1));

      this.bhDates = new Set(
        dates
          .map((date) => this.ensureDate(date))
          .filter((date) => date !== null)
          .map((date) => this.formatDate(date as Date)),
      );

      this.checkWarning();
    } catch (error) {
      console.error('Error loading bank holiday dates:', error);
    }
  }

  private checkWarning() {
    if (!this._earliest || !this._latest) {
      this.warning = false;
      return;
    }

    this.warning = this.rangeContainsWeekendOrHoliday(this._earliest, this._latest);
  }

  private rangeContainsWeekendOrHoliday(start: Date, end: Date): boolean {
    const currentDate = new Date(start);
    while (currentDate <= end) {
      if (this.isWeekendOrHoliday(currentDate)) {
        return true;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return false;
  }

  private isWeekendOrHoliday(date: Date): boolean {
    const dayOfWeek = date.getDay();
    return dayOfWeek === 0 || dayOfWeek === 6 || this.bhDates.has(this.formatDate(date));
  }

  private formatDate(date: Date): string {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

  private ensureDate(value: string | Date | null): Date | null {
    if (!value) return null;
    const date = value instanceof Date ? value : new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }
}
